import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Hls from 'hls.js';
import {
  changeVideoCurrentTime,
  changeVideoDuration,
  changeVideoInTime,
  changeVideoOutTime,
  initVideo,
} from 'redux/actions/actions';
import { HlsConfig } from 'commons/constants/KeyFlowConfig';

export default function useVideo() {
  const dispatch = useDispatch();

  const [hls, setHls] = useState<Hls>(new Hls(HlsConfig));
  const [bufferSecond, setBufferSecond] = useState<number>(0);

  const onInitVideo = useCallback(
    (video: HTMLVideoElement, url: string, fps: number) => {
      dispatch(initVideo({ fps }));
      // if (Hls.isSupported()) {
      //   hls.loadSource(url);
      //   hls.attachMedia(video);
      //   hls.on(Hls.Events.FRAG_LOADED, function (event, data: Hls.fragLoadedData) {
      //     setBufferSecond(data.frag.start);
      //   });
      // } else {
      //   console.error('Hls.js is not supported.');
      //   throw new Error('Hls.js is not supported.');
      // }
    },
    [dispatch],
  );

  const onChangeVideoInTime = useCallback(
    (inTime: number) => {
      dispatch(changeVideoInTime({ inTime }));
    },
    [dispatch],
  );

  const onChangeVideoOutTime = useCallback(
    (outTime: number) => {
      dispatch(changeVideoOutTime({ outTime }));
    },
    [dispatch],
  );

  const onChangeVideoDuration = useCallback(
    (duration: number) => {
      dispatch(changeVideoDuration({ duration }));
    },
    [dispatch],
  );
  const onChangeVideoCurrentTime = useCallback(
    (currentTime: number) => {
      dispatch(changeVideoCurrentTime({ currentTime }));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      hls,
      bufferSecond,
      onChangeVideoInTime,
      onChangeVideoOutTime,
      onChangeVideoDuration,
      onChangeVideoCurrentTime,
      onInitVideo,
    }),
    [
      hls,
      bufferSecond,
      onChangeVideoInTime,
      onChangeVideoOutTime,
      onChangeVideoDuration,
      onInitVideo,
      onChangeVideoCurrentTime,
    ],
  );
}
